module.exports = __webpack_public_path__ + "img/mail_sent_llm.43c52ee4.svg";